<re-captcha
  #captcha
  *ngIf="config.json.newRecaptchaSiteKey"
  (resolved)="$event && onResolved($event)"
  size="invisible"
  siteKey="{{ config.json.newRecaptchaSiteKey }}"
></re-captcha>
